import { render } from "./ActualitePoste.vue?vue&type=template&id=fe4626c6&scoped=true&ts=true"
import script from "./ActualitePoste.vue?vue&type=script&lang=ts"
export * from "./ActualitePoste.vue?vue&type=script&lang=ts"

import "./ActualitePoste.vue?vue&type=style&index=0&id=fe4626c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4626c6"]])

export default __exports__